import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import {
  UpdateDocumentTemplateMutation,
  UpdateDocumentTemplateMutationVariables,
} from '@/gql/graphql';

const UpdateDocumentTemplate = graphql(`
  mutation UpdateDocumentTemplate($input: UpdateDocumentTemplateInput!) {
    updateDocumentTemplate(input: $input) {
      id
      name
      description
      templateHtml
    }
  }
`);

const useUpdateDocumentTemplate = (
  options?: UseMutationOptions<
    UpdateDocumentTemplateMutation,
    unknown,
    UpdateDocumentTemplateMutationVariables['input']
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UpdateDocumentTemplate, {
        input,
      });
    },
    onSettled: (_data, _error, variables) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountDocumentTemplates(),
      });
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountDocumentTemplate(variables.id),
      });
    },
    ...options,
  });
};

export default useUpdateDocumentTemplate;
